import React, { Component } from "react";

class InternalError extends Component {
  constructor(props) {
    super(props);
    this.state = { apiResponse: "" };
  }

  render() {
    return (
      <div className="alert alert-danger" role="alert">
        Internal error occured
      </div>
    );
  }
}

export default InternalError;
